import jsPDF from "jspdf";
import "jspdf-autotable";

export const exportProfitLossPDF = ({ profitLossData, fromDate, toDate, societyName }) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "A4",
  });

  // ---------- Helper Functions ----------
  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatCurrency = (amount) => {

    if (amount) {
      const numberFormat = new Intl.NumberFormat("en-IN", {
        style: "decimal",
        minimumFractionDigits: 2,
      });
      return numberFormat.format(amount || 0);
    } else {
      return "";
    }

  };

  const reportTitle = `Profit & Loss Statement for the Period : ${formatDate(fromDate)} To ${formatDate(toDate)}`;
  const reportDateTime = new Date().toLocaleString("en-IN", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const leftMargin = 14;
  const rightMargin = 14;
  const headerHeight = 28;

  // ---------- Header ----------
  const drawHeader = () => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(societyName || "Society Name", doc.internal.pageSize.getWidth() / 2, 15, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(reportTitle, doc.internal.pageSize.getWidth() / 2, 23, { align: "center" });
  };

  // ---------- Table Body ----------
  const tableRows = profitLossData.length
    ? profitLossData.map((pl) => {
        // Define row styles
        let rowStyle = {};
        let textColor = [0, 0, 0]; // default black
        let bgColor = null;

        if (pl.particulars === "TOTAL INCOME" || pl.particulars === "TOTAL EXPENSES") {
          rowStyle = { fontStyle: "bold" };
          bgColor = [240, 240, 240];
        } else if (pl.inc_exp === 1 || pl.inc_exp === 11) {
          rowStyle = { fontStyle: "bold" };
          bgColor = [200, 230, 255]; // light blue
        } else if (pl.inc_exp === 21 && pl.particulars === "NET PROFIT") {
          rowStyle = { fontStyle: "bold" };
          textColor = [0, 128, 0]; // green
        } else if (pl.inc_exp === 21 && pl.particulars === "NET LOSS") {
          rowStyle = { fontStyle: "bold" };
          textColor = [200, 0, 0]; // red
        }

        return [
          {
            content: pl.particulars,
            styles: {
              halign: "left",
              textColor,
              fillColor: bgColor,
              ...rowStyle,
            },
          },
          {
            content: formatCurrency(pl.amount),
            styles: {
              halign: "right",
              textColor,
              fillColor: bgColor,
              ...rowStyle,
            },
          },
        ];
      })
    : [[{ content: "No Record found.", colSpan: 2, styles: { halign: "center" } }]];

  // ---------- Generate PDF Table ----------
  doc.autoTable({
    startY: headerHeight,
    margin: { top: headerHeight, left: leftMargin, right: rightMargin },
    head: [["Particulars", "Amount"]],
    body: tableRows,
    theme: "grid",
    styles: { fontSize: 9, cellPadding: 2 },
    headStyles: { fillColor: [41, 128, 185], textColor: 255, halign: "center" },
    columnStyles: {
      0: { cellWidth: 135, halign: "left" },
      1: { cellWidth: 50, halign: "right" },
    },
    didDrawPage: (data) => {
      // Header
      drawHeader();

      // Footer
      const pageWidth = doc.internal.pageSize.getWidth();
      const footerY = doc.internal.pageSize.getHeight() - 10;
      doc.setFontSize(9);
      doc.setDrawColor(150);
      doc.line(leftMargin, footerY - 3, pageWidth - rightMargin, footerY - 3);
      doc.text(`eSchool`, leftMargin, footerY + 2);
      doc.text(`Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`, pageWidth / 2, footerY + 2, { align: "center" });
      doc.text(`Generated on: ${reportDateTime}`, pageWidth - rightMargin, footerY + 2, { align: "right" });
    },
  });

  // ---------- Save PDF ----------
  doc.save(`ProfitLoss_${formatDate(fromDate)}_to_${formatDate(toDate)}.pdf`);
};
